import React from 'react';
import { TrashIcon } from './Icons/TrashIcon';


/**
 * AdminQuestion component renders a question with associated audio and video,
 * and provides functionality to handle answer changes and deletion of the question.
 * 
 * @param {number} itemID - The ID of the question item.
 * @param {string} question - The text of the question.
 * @param {string} audio - The audio associated with the question.
 * @param {string} video - The video associated with the question.
 * @param {function} onAnswerChange - Function to handle changes to the answer.
 * @param {function} onDelete - Function to handle the deletion of the question.
 * @returns {JSX.Element} A question component with action icons.
 */
export function AdminQuestion({ itemID, question, audio, video, onAnswerChange, onDelete }) {

    /**
     * Handles the answer change event.
     */
    const answerChange = () => {
        onAnswerChange(itemID, audio, video);
    };

    return (
        <div className="question-item" onClick={answerChange}>
            {question}
            <button
                type="button"
                className="btn btn-default btn-sm"
                onClick={() => onDelete(itemID)}
                title="Ta bort fråga"
            >
                <TrashIcon />
            </button>
        </div>
    );
}
